/**
 * Captcha service registry.
 *
 * Moved verbatim from components/text-widget/utils/captchaRegistry.ts. This
 * is the seam the public CaptchaService option builds on: the core needs a
 * captcha token, but not any particular captcha implementation, and a host
 * drawing its own UI has to be able to place the challenge itself.
 */

export interface ICaptchaService {
  isCaptchaVerified: boolean;
  loadCaptchaScript: () => void;
  resetOrRenderCaptcha: (host?: any, interactive?: boolean) => void;
  getResolvedCaptchaToken: () => string | undefined;
  reset: () => void;
  hideCaptchaUI?: () => void;
  isInteractiveChallenge?: () => boolean;
  /** Drop the managed (interactive) key so the next render is invisible again. */
  clearInteractiveChallenge?: () => void;
}

/** True when the service is currently set to draw the interactive challenge. Never throws. */
export function isInteractiveChallenge(service: ICaptchaService | null | undefined): boolean {
  try {
    return !!service?.isInteractiveChallenge?.();
  } catch (_e) {
    return false;
  }
}

class CaptchaServiceRegistryImpl {
  private defaultService: ICaptchaService | null = null;
  private scopedServices: WeakMap<object, ICaptchaService> = new WeakMap();

  set(service: ICaptchaService | null, scope?: object) {
    if (!service) {
      if (scope) this.scopedServices.delete(scope);
      else this.defaultService = null;
      return;
    }
    if (scope) this.scopedServices.set(scope, service);
    else this.defaultService = service;
  }

  get(scope?: object): ICaptchaService | null {
    if (scope) return this.scopedServices.get(scope) || this.defaultService;
    return this.defaultService;
  }
}

export const CaptchaServiceRegistry = new CaptchaServiceRegistryImpl();

